export const iPhoneDevices = [
    {
        name: 'iPhone 13',
        width: 1170,
        height: 2532,
    },
    {
        name: 'iPhone 13 mini',
        width: 1080,
        height: 2340,
    },
    {
        name: 'iPhone 13 Pro Max',
        width: 1284,
        height: 2778,
    },
    {
        name: 'iPhone 13 Pro',
        width: 1170,
        height: 2532,
    },
    {
        name: 'iPhone 12',
        width: 1170,
        height: 2532,
    },
    {
        name: 'iPhone 12 mini',
        width: 1080,
        height: 2340,
    },
    {
        name: 'iPhone 12 Pro Max',
        width: 1284,
        height: 2778,
    },
    {
        name: 'iPhone 12 Pro',
        width: 1170,
        height: 2532,
    },
    {
        name: 'iPhone SE 2nd gen',
        width: 750,
        height: 1334,
    },
    {
        name: 'iPhone 11 Pro Max',
        width: 1242,
        height: 2688,
    },
    {
        name: 'iPhone 11 Pro',
        width: 1125,
        height: 2436,
    },
    {
        name: 'iPhone 11',
        width: 828,
        height: 1792,
    },
    {
        name: 'iPhone XR',
        width: 828,
        height: 1792,
    },
    {
        name: 'iPhone XS Max',
        width: 1242,
        height: 2688,
    },

    {
        name: 'iPhone XS',
        width: 1125,
        height: 2436,
    },
    {
        name: 'iPhone X',
        width: 1125,
        height: 2436,
    },
    {
        name: 'iPhone 8 Plus',
        width: 1080,
        height: 1920,
    },
    {
        name: 'iPhone 8',
        width: 750,
        height: 1334,
    },
    {
        name: 'iPhone 7 Plus',
        width: 1242,
        height: 2208,
    },
    {
        name: 'iPhone 7',
        width: 750,
        height: 1334,
    },
    {
        name: 'iPhone SE 1st gen',
        width: 640,
        height: 1136,
    },
    {
        name: 'iPhone 6s Plus',
        width: 1242,
        height: 2208,
    },
    {
        name: 'iPhone 6s',
        width: 750,
        height: 1334,
    },
    {
        name: 'iPhone 6 Plus',
        width: 1242,
        height: 2208,
    },
    {
        name: 'iPhone 6',
        width: 750,
        height: 1334,
    },
]

export const otherWatchDevices = [
    {
        name: 'Huawei Watch GT (2018) ',
        width: 454,
        height: 454,
    },
    {
        name: 'LG Watch W7 (2018)',
        width: 360,
        height: 360,
    },
    {
        name: 'Samsung Galaxy Watch (2018)',
        width: 360,
        height: 360,
    },
    {
        name: 'Huawei Watch Magic (2018)',
        width: 390,
        height: 390,
    },
    {
        name: 'LG Watch Sport (2017)',
        width: 480,
        height: 480,
    },
    {
        name: 'Asus Zenwatch 3 (2016)',
        width: 400,
        height: 400,
    },
]

export const appleWatchDevices = [
    {
        name: 'Apple Watch 6 (44mm)',
        width: 368,
        height: 448,
    },
    {
        name: 'Apple Watch 6 (40mm) ',
        width: 324,
        height: 394,
    },
    {
        name: 'Apple Watch SE (44mm)',
        width: 368,
        height: 448,
    },
    {
        name: 'Apple Watch SE (40mm)',
        width: 324,
        height: 394,
    },
    {
        name: 'Apple Watch 5 (44mm) ',
        width: 368,
        height: 448,
    },
    {
        name: 'Apple Watch 5 (40mm) ',
        width: 324,
        height: 394,
    },
    {
        name: 'Apple Watch 4 (44mm) ',
        width: 368,
        height: 448,
    },
    {
        name: 'Apple Watch 4 (40mm) ',
        width: 324,
        height: 394,
    },
    {
        name: 'Apple Watch 3 (42mm) ',
        width: 312,
        height: 390,
    },
    {
        name: 'Apple Watch 3 (38mm) ',
        width: 272,
        height: 340,
    },
]

export function desktopDevices() {
    const scale = window.devicePixelRatio || 1
    const width = window.screen.width * scale
    const height = window.screen.height * scale
    return [
        {
            name: `Recommended (${width} x ${height})`,
            width: width,
            height: height,
        },
        {
            name: `6K (6016 x 3384)`,
            width: 6016,
            height: 3384,
        },
        {
            name: `5K (5120 x 2880)`,
            width: 5120,
            height: 2880,
        },
        {
            name: `4K (3840 x 2160)`,
            width: 3840,
            height: 2160,
        },
        {
            name: `1080p (1920 x 1080)`,
            width: 1920,
            height: 1080,
        },
        {
            name: `720p (1280 x 720)`,
            width: 1280,
            height: 720,
        },
    ]
}

export const androidTabletDevices = [
    {
        name: 'Nexus 9',
        width: 1536,
        height: 2048,
    },
    {
        name: 'Nexus 7 (2013)',
        width: 1200,
        height: 1920,
    },
    {
        name: 'Samsung Galaxy Tab 10',
        width: 800,
        height: 1280,
    },
    {
        name: 'Chromebook Pixel',
        width: 1700,
        height: 2560,
    },
]

export const androidDevices = [
    {
        name: 'Nexus 6P',
        width: 1440,
        height: 2560,
    },
    {
        name: 'Nexus 5X',
        width: 1080,
        height: 2560,
    },
    {
        name: 'Google Pixel 3 XL',
        width: 1440,
        height: 2960,
    },
    {
        name: 'Google Pixel 3',
        width: 1080,
        height: 2160,
    },
    {
        name: 'Google Pixel 2 XL',
        width: 1440,
        height: 2560,
    },
    {
        name: 'Google Pixel XL',
        width: 1440,
        height: 2560,
    },
    {
        name: 'Google Pixel',
        width: 1080,
        height: 1920,
    },
    {
        name: 'Samsung Galaxy Note 9',
        width: 1440,
        height: 2960,
    },
    {
        name: 'Samsung Galaxy Note 5',
        width: 1440,
        height: 2560,
    },
    {
        name: 'LG G5',
        width: 1440,
        height: 2560,
    },
    {
        name: 'One Plus 3',
        width: 1080,
        height: 1920,
    },
    {
        name: 'Samsung Galaxy S9+',
        width: 1440,
        height: 2960,
    },
    {
        name: 'Samsung Galaxy S9',
        width: 1440,
        height: 2960,
    },
    {
        name: 'Samsung Galaxy S8+',
        width: 1440,
        height: 2960,
    },
    {
        name: 'Samsung Galaxy S8',
        width: 1440,
        height: 2960,
    },
    {
        name: 'Samsung Galaxy S7 Edge',
        width: 1440,
        height: 2560,
    },
    {
        name: 'Samsung Galaxy S7',
        width: 1440,
        height: 2560,
    },
]

export const iPadDevices = [
    {
        name: 'iPad Mini (6th gen)',
        width: 1488,
        height: 2266,
    },
    {
        name: 'iPad 9th gen',
        width: 1620,
        height: 2160,
    },
    {
        name: 'iPad Pro (5th gen 12.9")',
        width: 2048,
        height: 2732,
    },
    {
        name: 'iPad Pro (5th gen 11")',
        width: 1668,
        height: 2388,
    },
    {
        name: 'iPad Air (4th gen)',
        width: 1640,
        height: 2360,
    },
    {
        name: 'iPad 8th gen',
        width: 1620,
        height: 2160,
    },
    {
        name: 'iPad Pro (4th gen 12.9")',
        width: 2048,
        height: 2732,
    },
    {
        name: 'iPad Pro (4th gen 11")',
        width: 1668,
        height: 2388,
    },
    {
        name: 'iPad 7th gen',
        width: 1620,
        height: 2160,
    },
    {
        name: 'iPad Mini (5th gen)',
        width: 1536,
        height: 2048,
    },
    {
        name: 'iPad Air (3rd gen)',
        width: 1668,
        height: 2224,
    },
    {
        name: 'iPad Pro (3rd gen 12.9")',
        width: 2048,
        height: 2732,
    },
    {
        name: 'iPad Pro (3rd gen 11")',
        width: 1668,
        height: 2388,
    },
    {
        name: 'iPad 6th gen',
        width: 1536,
        height: 2048,
    },
    {
        name: 'iPad Pro (2nd gen 12.9")',
        width: 2048,
        height: 2732,
    },
    {
        name: 'iPad Pro (2nd gen 10.5")',
        width: 1668,
        height: 2224,
    },
    {
        name: 'iPad 5th gen',
        width: 1536,
        height: 2048,
    },
]
